import React from "react"
import { UseFormMethods } from "react-hook-form"
import { FormulaireSchemaType } from "../../../lib/formulaireContext/validation/formulaire.schema"
import { SectionHelperText } from "./SectionHelperText";
import { Paper, Box, Typography, Grid } from "@material-ui/core";
import { FormTextField } from "../Fields/FormTextField";
import { Controller } from "react-hook-form";
import { FormDateTimeField } from "../Fields/FormDateTimeField";
import { FormSelectField } from "../Fields/FormSelectField";
import { MediaEnum } from "../../../lib/formulaireContext/validation/formulaire.schema";


type FieldConfig = {
    name: string;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    helperText?: string;
}

const firstDiffusionFields: FieldConfig[] = [
    { name: "first_diffusion.broadcaster", label: "Diffuseur", required: true },
]

export const FirstDiffusionSection = ({ form }: { form: UseFormMethods<FormulaireSchemaType> }) => {
    const { control, formState } = form
    return (
        <Paper elevation={2} style={{ padding: 18, marginBottom: 26, marginTop: 26 }}>
            <Typography variant="h5" component="h2" gutterBottom>
                Première diffusion
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} key={"firstDiffusion.media"}>
                    <FormSelectField
                        label="Média"
                        formState={formState}
                        name="first_diffusion.media"
                        control={control}
                        required={true}
                        options={[{ value: MediaEnum.RADIO, label: "Radio" }, { value: MediaEnum.TV, label: "Télévision" }]}
                    />
                </Grid>
                {firstDiffusionFields.map((field) => (
                    <Grid item xs={12} sm={6} key={field.name}>
                        <FormTextField
                            label={field.label}
                            name={field.name}
                            control={control}
                            disabled={field.readOnly}
                            required={field.required}
                            formState={formState}
                            helperText={field.helperText}
                        />
                    </Grid>
                ))}

                <Grid item xs={12} sm={6} key={"firstDiffusion.dateTime"}>
                    <FormDateTimeField
                        label="Date / Période de diffusion"
                        name="first_diffusion.dateTime"
                        control={control}
                        formState={formState}
                        required={true}
                    />
                </Grid>
            </Grid>
            <SectionHelperText text="2) Pour une diffusion en télévision française, merci de préciser une date, une heure et une chaîne en particulier" />
        </Paper>
    )
}